import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./AdminPanel";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import CustomerDashboard from "./CustomerDashboard";
import SubAdminPanel from "./sub-adminPanel";
import PrivateRoute from "./PrivateRoute";
import { auth, db } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { ToastContainer } from "react-toastify";




const App = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        }
      } else {
        setUserRole(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Router>
           <ToastContainer />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/ForgotPassword" element={<ForgotPassword/>} />
        {/* <Route path="/AdminPanel" element={<AdminPanel />} /> */}
   
        <Route
          path="/AdminPanel"
          element={
            <PrivateRoute role="admin" userRole={userRole}>
              <AdminPanel />
            </PrivateRoute>
          }
        />


        <Route
          path="/CustomerDashboard"
          element={
            <PrivateRoute role="customer" userRole={userRole}>
              <CustomerDashboard />
            </PrivateRoute>
          }
        />


        <Route
          path="/sub-adminPanel"
          element={
            <PrivateRoute role="sub-admin" userRole={userRole}>
              < SubAdminPanel/>
            </PrivateRoute>
          }
        />





      </Routes>
   
    </Router>

    
  );
};

export default App;
